import Popup from 'components/Popup';
import React, { createContext, ReactNode, useRef, useState } from 'react';

type ContextProps = {
  controlStatus: boolean;
  buttonIndex: number;
  popupRef: any;
  markRef: any;
  gender: boolean;
  dragStart: boolean;
  percentage: number;
  setPercentage: React.Dispatch<React.SetStateAction<number>>;
  setDrag: React.Dispatch<React.SetStateAction<boolean>>;
  setControlStatus: React.Dispatch<React.SetStateAction<boolean>>;
  setButtonIndex: React.Dispatch<React.SetStateAction<number>>;
  setGender: React.Dispatch<React.SetStateAction<boolean>>;
};

type Props = {
  children: ReactNode;
};

export const ControlContext = createContext<ContextProps>({
  controlStatus: true,
  buttonIndex: 0,
  popupRef: null,
  markRef: null,
  gender: true,
  dragStart: false,
  percentage: 0,
  setPercentage: () => {},
  setDrag: () => {},
  setButtonIndex: () => {},
  setControlStatus: () => {},
  setGender: () => {},
});

export const ControlProvider = ({ children }: Props) => {
  const [controlStatus, setControlStatus] = useState<boolean>(true);
  const [buttonIndex, setButtonIndex] = useState<number>(-1);
  const [dragStart, setDrag] = useState<boolean>(false);
  const [gender, setGender] = useState<boolean>(false);
  const [percentage, setPercentage] = useState<number>(0);
  const popupRef = useRef<any>();
  const markRef = useRef<any>();
  return (
    <ControlContext.Provider
      value={{
        controlStatus,
        buttonIndex,
        popupRef,
        markRef,
        gender,
        dragStart,
        percentage,
        setDrag,
        setGender,
        setControlStatus,
        setButtonIndex,
        setPercentage,
      }}
    >
      {children}
    </ControlContext.Provider>
  );
};
